import {getWarehouseUploadHistory} from '@/services/ProductsService/Fullfillment/warehouse'
import {useQueries} from '@tanstack/react-query'

export const useWarehouseUploadHistory = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['WAREHOUSE_UPLOAD_HISTORY'],
        queryFn: getWarehouseUploadHistory,
      },
    ],
  })

  const responseData = results?.[0]?.data
  const uploadHistory = responseData && responseData.data ? responseData.data : responseData

  return {
    warehouseUploadHistoryData: uploadHistory || [],
  }
}
